export default __webpack_public_path__ + "static/media/8e71c6bccdf04f83ac7305cbdcd4a856.svg";